import { useEffect, useState } from 'react'

import { AppLoading } from '@/components/AppLoading'

import { useAuth } from '../../context/AuthContext'
import {
  redirectToLogin,
  redirectToLogout,
  useIsLogged,
  useIsLoggedCarkulka,
} from '../../hooks/useAccount'

export const WithAuth = <T extends object>(
  WrappedComponent: React.ComponentType<T>,
) => {
  const NewComponent = (props: T) => {
    const { data: dataCakulka, refetch: refetchCarkulka } = useIsLoggedCarkulka(
      {
        enabled: false,
      },
    )
    const { data, refetch } = useIsLogged({
      enabled: false,
      onError: () => redirectToLogout(),
    })
    const [showComponent, setShowComponent] = useState(false)

    const isLoggedCarkulka = dataCakulka?.data?.logged
    const isLoggedOkApps = data?.data?.logged
    const buildDate = data?.data?.buildDate

    const ctx = useAuth()
    useEffect(() => {
      if (isLoggedOkApps) ctx?.login(data.data)
      else ctx?.logout()
    }, [isLoggedOkApps])

    useEffect(() => {
      refetchCarkulka()
      refetch()
    }, [])

    useEffect(() => {
      if (isLoggedCarkulka == false || isLoggedOkApps == false)
        redirectToLogin()
      else if (isLoggedCarkulka == true && isLoggedOkApps == true)
        setShowComponent(true)
    }, [isLoggedCarkulka, isLoggedOkApps])

    useEffect(() => {
      if (!!buildDate && isLoggedOkApps) {
        // vynucení reload stránky, pokud se změní verze API
        const lastBuildDate = window.localStorage.getItem('api-build-date')
        window.localStorage.setItem('api-build-date', buildDate)

        if (buildDate !== lastBuildDate) window.location.reload()
      }
    }, [buildDate])

    return (
      <>
        {!showComponent && <AppLoading />}
        {showComponent && <WrappedComponent {...props} />}
      </>
    )
  }

  return NewComponent
}
